import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

const getDate = new Date()
export default class Footer extends Component {
    createElementCircle = () => {
        return (
            <>
                &nbsp;&nbsp;
                <svg height="10" width="10">
                    <circle cx="2.5" cy="2.5" r="2" fill="black" />
                    Sorry, your browser does not support inline SVG.
                </svg>
                &nbsp;
            </>
        )
    }
    renderFooterKota = () => {
        return (
            <>
                JAKARTA {this.createElementCircle()}
                SEMARANG {this.createElementCircle()}
                YOGYAKARTA {this.createElementCircle()}
                SOLO {this.createElementCircle()}
                SALATIGA {this.createElementCircle()}
                MAGELANG {this.createElementCircle()}
                PURWOKERTO {this.createElementCircle()}
                SURABAYA {this.createElementCircle()}
                BALI {this.createElementCircle()}
                MATARAM
            </>
        )
    }
    render() {
        return (
            <footer className="foothers-foothers">
                <div className="foothers-container position-relative" style={{ 
                    paddingBottom: "5rem",
                    marginBottom: "1rem",
                 }}>
                    <div className="foothers-logofoother">
                        <NavLink to="/"><img
                            alt="Main Logo"
                            src="https://minio.nexa.net.id/nexa/logo_nexa_500.png"
                            className="foothers-image"
                        />
                        </NavLink>
                        <div className="foothers-container1"></div>
                        <span className="foothers-text">
                            <span>Next Level Experience</span>
                        </span>

                        <div className="foothers-text position-absolute bottom-0">
                            <img
                                alt="Main Logo"
                                src="./assets/images/iso-9001.png"
                                style={{
                                    width: "150px",
                                    objectFit: "cover",
                                    marginBottom: "var(--dl-space-space-unit)"
                                }}
                            />
                            <img
                                alt="Main Logo"
                                src="./assets/images/iso-27001.png"
                                style={{
                                    width: "150px",
                                    objectFit: "cover",
                                    marginBottom: "var(--dl-space-space-unit)"
                                }}
                            />
                        </div>
                    </div>
                    <div className="foothers-companyfoother">
                        <NavLink className="foothers-text01" to="/company"><span className="foothers-text01"><span>Company</span></span></NavLink>
                        <span className="foothers-text02">
                            <NavLink to="/company"><span>About Us</span></NavLink>
                            <br />
                            <span>​</span>
                            <NavLink to="/career"><span>Career</span></NavLink>
                            <br />
                            <NavLink to="/client"><span>Clients</span></NavLink>
                            <br />
                            <NavLink to="/contact"><span>Contact</span></NavLink>
                            <span></span>
                        </span>
                    </div>
                    <div className="foothers-servicefoother">
                        <NavLink className="foothers-text01" to="/services"><span className="foothers-text10"><span>Services</span></span></NavLink>
                        <span className="foothers-text11">

                            <span></span>
                            <NavLink to="/nexatel"><span>Nexatel</span></NavLink>
                            <br />
                            <NavLink to="/nexaapps"><span>Nexa Apps</span></NavLink>
                            <br />
                            <NavLink to="/nexadata"><span>Nexa Data</span></NavLink>
                            <br />
                            <NavLink to="/nexadigital"><span>Nexa Digital</span></NavLink>
                            <br />
                            <NavLink to="/solution"><span>Nexa Solutions</span></NavLink>
                            <span></span>
                        </span>
                    </div>
                    <div className="foothers-solutionfoother">
                        <NavLink className="foothers-text01" to="/solution"><span className="foothers-text21"><span>Solutions</span></span></NavLink>
                        <span className="foothers-text22">
                            <NavLink to="/corporate"><span>Corporate</span></NavLink>
                            <br />
                            <NavLink to="/education"><span>Education</span></NavLink>
                            <br />
                            <NavLink to="/goverment"><span>Government</span></NavLink>
                            <br />
                            <NavLink to="/hospitality"><span>Hospitality</span></NavLink>
                            <br />
                            <NavLink to="/manufacture"><span>Manufacture</span></NavLink>
                        </span>
                    </div>
                    <div className="foothers-supportfoother">
                        <NavLink className="foothers-text01" to="/subscribe"><span className="foothers-text28"><span>Support</span></span></NavLink>
                        <span className="foothers-text29">
                            <NavLink to="/areas"><span>Areas</span></NavLink>
                            <br />
                            <NavLink to="/subscribe"><span>Subscription</span></NavLink>
                            <br />
                            <span className="d-none">Payment Method</span>
                        </span>
                    </div>
                    <div className="foothers-newsfoother">
                        <NavLink className="foothers-text01" to="/news"><span className="foothers-text33"><span>News & Article</span></span></NavLink>
                        <span className="foothers-text34">
                            <NavLink to="/news"><span>News &amp; Article</span></NavLink>
                            <br />
                            <span className="d-none">Event</span>
                        </span>
                    </div>
                </div>
                <div className="foothers-container-mobile">
                    <div className="foothers-logofoother1">
                        <NavLink to="/"><img
                            alt=""
                            src="public/playground_assets/logo%20nexa-500h.png"
                            className="foothers-image1"
                        />
                        </NavLink>
                        <div className="foothers-container2"></div>
                        <span className="foothers-text37">
                            <span>Your Trusted Business Enabler</span>
                        </span>
                        <div className="foothers-solutionfoother1">
                            <span className="foothers-text38"><span>Solutions</span></span>
                            <span className="foothers-text39">
                                <span>Corporate</span>
                                <br />
                                <span>Education</span>
                                <br />
                                <span>Government</span>
                                <br />
                                <span>Hospitality</span>
                                <br />
                                <span>Manufacture</span>
                            </span>
                        </div>
                    </div>
                    <div className="foothers-companyfoother1">
                        <span className="foothers-text45"><span>Company</span></span>
                        <span className="foothers-text46">
                            <span>About Us</span>
                            <br />
                            <span>​</span>
                            <span>Career</span>
                            <br />
                            <span>Clients</span>
                            <br />
                            <span>Contact</span>
                            <span></span>
                        </span>
                        <div className="foothers-servicefoother1">
                            <span className="foothers-text54"><span>Services</span></span>
                            <span className="foothers-text55">
                                <span>About Us</span>
                                <br />
                                <span></span>
                                <span>Nexatel</span>
                                <br />
                                <span>Nexa Apps</span>
                                <br />
                                <span>Nexa Data</span>
                                <br />
                                <span>Nexa Digital</span>
                                <br />
                                <NavLink to="/solution"><span>Nexa Solutions</span></NavLink>
                                <span></span>
                            </span>
                        </div>
                    </div>
                    <div className="foothers-supportfoother1">
                        <span className="foothers-text65"><span>Support</span></span>
                        <span className="foothers-text66">
                            <NavLink to="/areas" className="foothers-text65"><span>Areas</span></NavLink>
                            <br />
                            <span>Subscription</span>
                            <br />
                            <span>Payment Method</span>
                        </span>
                        <div className="foothers-newsfoother1">
                            <span className="foothers-text70"><span>News & Article</span></span>
                            <span className="foothers-text71">
                                <span>News &amp; Article</span>
                                <br />
                                <span>Event</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div className="foothers-line"></div>
                <div className="foothers-container3">
                    <div className="foothers-container4">
                        <span className="foothers-text74">
                            <span>
                                {this.renderFooterKota()}
                            </span>
                        </span>
                        <span className="foothers-text75">
                            <span>
                                @ Copyright {getDate.getFullYear()} PT Internet Mulia Untuk Negeri. All Rights Reserved.
                            </span>
                        </span>
                    </div>
                    <div className="foothers-container5">
                        <span className="foothers-text76"><span>Find us at</span></span>
                        <div className="foothers-container6">
                            <div className="foothers-container7 w-100">

                                <button className='foothers-icon w-100 h-100'>
                                    <svg onClick={() => window.open("https://www.linkedin.com/company/78380888/", "_blank")}
                                        viewBox="0 0 877.7142857142857 1024"
                                        className="foothers-icon w-100 h-100"
                                    >
                                        <path
                                            d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"
                                        ></path>
                                    </svg>
                                </button>

                                <button className='foothers-icon4 w-100 h-100'>
                                    <svg onClick={() => window.open("https://www.instagram.com/nexanet.id/", "_blank")} viewBox="0 0 1024 1024"
                                        className="foothers-icon w-100 h-100">
                                        <path
                                            d="M298.667 42.667c-70.699 0-134.741 28.715-181.035 74.965s-74.965 110.336-74.965 181.035v426.667c0 70.699 28.715 134.741 74.965 181.035s110.336 74.965 181.035 74.965h426.667c70.699 0 134.741-28.715 181.035-74.965s74.965-110.336 74.965-181.035v-426.667c0-70.699-28.715-134.741-74.965-181.035s-110.336-74.965-181.035-74.965zM298.667 128h426.667c47.147 0 89.728 19.072 120.661 50.005s50.005 73.515 50.005 120.661v426.667c0 47.147-19.072 89.728-50.005 120.661s-73.515 50.005-120.661 50.005h-426.667c-47.147 0-89.728-19.072-120.661-50.005s-50.005-73.515-50.005-120.661v-426.667c0-47.147 19.072-89.728 50.005-120.661s73.515-50.005 120.661-50.005zM724.864 478.848c-6.4-41.472-24.363-79.232-50.944-109.525-32.171-36.736-76.971-62.507-128.384-70.144-19.797-3.157-41.387-3.285-63.019-0.085-58.283 8.619-107.563 40.149-140.032 83.925s-48.341 100.139-39.68 158.379 40.149 107.563 83.925 140.032 100.139 48.341 158.379 39.68 107.563-40.149 140.032-83.925 48.341-100.139 39.68-158.379zM640.469 491.392c5.205 34.987-4.267 68.651-23.808 95.019s-49.067 45.184-84.011 50.347-68.651-4.267-95.019-23.808-45.184-49.067-50.347-84.011 4.267-68.651 23.808-95.019 49.067-45.184 84.011-50.347c13.355-1.963 26.24-1.792 37.12-0.085 31.573 4.693 58.283 20.053 77.568 42.069 16 18.261 26.88 41.088 30.72 65.835zM789.333 277.333c0-23.552-19.115-42.667-42.667-42.667s-42.667 19.115-42.667 42.667 19.115 42.667 42.667 42.667 42.667-19.115 42.667-42.667z"
                                        ></path></svg>
                                </button>

                                <button className='foothers-icon w-100 h-100'>
                                    <svg onClick={() => window.open("https://www.facebook.com/Nexanetid-109427088241490/", "_blank")}
                                        viewBox="0 0 877.7142857142857 1024"
                                        className="foothers-icon4 w-100 h-100"
                                    >
                                        <path
                                            d="M713.143 73.143c90.857 0 164.571 73.714 164.571 164.571v548.571c0 90.857-73.714 164.571-164.571 164.571h-107.429v-340h113.714l17.143-132.571h-130.857v-84.571c0-38.286 10.286-64 65.714-64l69.714-0.571v-118.286c-12-1.714-53.714-5.143-101.714-5.143-101.143 0-170.857 61.714-170.857 174.857v97.714h-114.286v132.571h114.286v340h-304c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571z"
                                        ></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}